export default `float s=2., e;
    for(int j=0;j++<7;)
      s*=e=2.2/clamp(dot(p,p),.3,1.2),
      p=abs(p)*e-vec3(1.0,8.0,1.0);
    return length(cross(p,vec3(1.0,1.0,-1.0)))/s;
  }`